module.exports = __webpack_public_path__ + "static/media/whiteAddThin.24c87557.svg";